import { gql } from '@apollo/client';

// NOTE: Only exists on api's `fdic` branch.
export const SALE_ACKNOWLEDGEMENT_DOCUMENT_QUERY = gql`
  query SaleAcknowledgementDocument($saleId: ID!, $docType: SaleDocumentType!) {
    saleAcknowledgementDocument(sale_id: $saleId, doc_type: $docType) {
      __typename
      doc_type
      title
      version
      text
      document_sha256
    }
  }
`;
